<template>
  <div class="register-page">
    <!-- <top-announce-bar
      v-show="!isReferralPage"
      :is-desktop="true"
    /> -->
    <div class="register-header">
      <div class="fiflbox-logo" />
      <h1>피플박스 파트너사 가입</h1>
      <span>
        회원 50인 미만이라면 무료로 이용할 수 있습니다.
        <br>
        가입 상담은 1:1 채팅으로 문의해 주세요.
      </span>
    </div>
    <div class="register-form-container">
      <el-form
        :model="form"
        :rules="formValidateRules"
        label-position="top"
        label-width="100px"
        @validate="onValidateChange"
      >
        <el-row :gutter="15">
          <el-col
            :xs="24"
            :md="12"
          >
            <el-form-item
              label="센터"
              prop="name"
              data-test="form-item-center-name"
            >
              <el-input
                v-model="form.name"
                placeholder="센터의 공식 명칭을 입력해주세요"
              />
            </el-form-item>
            <el-form-item
              label="센터 타입"
              prop="category"
              data-test="form-item-category"
            >
              <el-select
                v-model="form.category"
                placeholder="센터의 타입을 선택해주세요"
                data-test="select-category"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="(exerciseType, index) in exerciseTypeOptions"
                  :key="index"
                  :label="exerciseType.label"
                  :value="exerciseType.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item prop="exercise_type">
              <div slot="label">
                센터 로고 (선택)
                <span class="label-description">
                  가입 후 등록하거나 다른 로고로 교체하실 수 있습니다.<br>
                  (400 x 400px 사이즈 권장/ jpg , png  지원 /최대 3MB) 
                </span>
              </div>

              <CenterLogoUploadField 
                :origin-logo-image-src="form.logo"
                @change="onLogoImageChanged"
              />
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :md="12"
          >
            <el-form-item
              label="센터 주소"
              data-test="form-item-address"
              prop="address"
            >
              <AddressInputWithMap
                :map-visible="true"
                :show-guide="true"
                :address="form.address"
                @change="onAddressChange"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <div class="form-divide-line" />
        <el-row :gutter="15">
          <el-col
            :xs="24"
            :md="12"
          >
            <el-form-item
              label="관리자 성함"
              prop="user.name"
              data-test="form-item-user-name"
            >
              <el-input
                v-model="form.user.name"
                placeholder="반드시 실명을 입력해주세요"
              />
            </el-form-item>
            <el-form-item
              label="휴대전화번호"
              prop="user.phone_number"
              data-test="form-item-user-phone-number"
            >
              <el-input
                v-model="form.user.phone_number"
                placeholder="-을 제외하고 번호만 입력해주세요"
              />
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :md="12"
          >
            <el-form-item
              label="이메일 계정"
              prop="user.email"
              data-test="form-item-user-email"
            >
              <el-input
                ref="desktop-email-ref"
                v-model="form.user.email"
                type="email"
                placeholder="수신 가능한 이메일을 입력해주세요"
              />
            </el-form-item>
            <el-form-item
              label="비밀번호"
              prop="user.password"
              data-test="form-item-user-password"
            >
              <el-input
                v-model="form.user.password"
                type="password"
                placeholder="8자리 이상의 영문/숫자를 조합해주세요"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <div class="form-divide-line" />
        <el-row :gutter="15">
          <el-col :span="24">
            <el-form-item
              label="피플박스 유입 경로"
              prop="inflow"
              data-test="form-item-inflow"
            >
              <el-select
                v-model="form.inflow"
                placeholder="피플박스 유입 경로를 선택해주세요"
                @change="form.inflow_detail = ''"
                :popper-append-to-body="true"
                :disabled="inflowInputDisabled"
                class="inflow-select-input"
              >
                <el-option
                  v-for="(inflowOption, index) in inflowOptions"
                  :key="index"
                  :label="inflowOption.label"
                  :value="inflowOption.value"
                />
              </el-select>
              <el-form-item
                v-if="form.inflow === 4 || form.inflow === 5 || form.inflow === 6"
                prop="inflow_detail"
                class="inflow-write-input"
              >
                <el-input
                  v-model="form.inflow_detail"
                  :placeholder="presentInflowDetailPlaceholder"
                  :disabled="inflowInputDisabled"
                />
              </el-form-item>
              <span
                v-if="form.inflow === 4"
                class="inflow-description"
              >
                추천인 입력 시 특별 프로모션이 적용됩니다. (유료 결제 시 1개월 무료)
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="form-divide-line" />
        <el-row :gutter="15">
          <el-col :span="24">
            <el-form-item label="필수 동의 항목">
              <el-checkbox
                v-model="isPolicyChecked1"
                data-test="policy-check"
                class="policy-check"
                size="medium"
              >
                <a
                  href="https://fiflfifl.com/terms-conditions"
                  target="_blank"
                >
                  서비스 이용약관
                </a> 및
                <a
                  href="https://fiflfifl.com/privacypolicy"
                  target="_blank"
                >
                  개인정보 처리방침
                </a>를 읽었으며 이에 동의합니다.
              </el-checkbox>
              <br>
              <el-checkbox
                v-model="isPolicyChecked2"
                data-test="policy-check2"
                class="policy-check"
                size="medium"
              >
                부정한 목적 및 타사업장으로 가입한 사실이 밝혀질 경우 관련된 모든 계정의 접근이 통보없이 차단됩니다.
              </el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div style="text-align: center;padding-bottom: 50px">
        <el-button
          class="default register-form__submit"
          :disabled="!isFormValidated"
          :loading="isLoading"
          data-test="register-form-submit-button"
          @click="handleSignUp"
        >
          파트너사 가입
        </el-button>
      </div>
    </div>
    <section class="mb__register-header__container">
      <!-- <top-announce-bar
        v-show="!isReferralPage"
        :is-desktop="false"
      /> -->
      <div class="mb__register-header">
        <button 
          @click="handleMovePage('back')" 
          class="ic-arrow-left"
        />
        <h1>파트너사 가입</h1>
      </div>
    </section>
    <div 
      ref="mbForm" 
      class="mb__register-form-container"
    >
      <el-form
        class="mb-form"
        :model="form"
        :rules="formValidateRules"
        label-position="top"
        label-width="100px"
        @validate="onValidateChange"
      >
        <div class="page-wrapper">
          <div 
            class="page-scroll-wrapper"
            :style="{visibility : mbPageIndex === 1 ? 'hidden' : 'visible' }"
          >
            <el-row :gutter="15">
              <el-col
                :xs="24"
                :md="12"
              >
                <el-form-item
                  label="관리자 성함"
                  prop="user.name"
                  data-test="form-item-user-name"
                >
                  <el-input
                    ref="mobile-name-ref"
                    v-model="form.user.name"
                    placeholder="반드시 실명을 입력해주세요"
                  />
                </el-form-item>
                <el-form-item
                  label="휴대전화번호"
                  prop="user.phone_number"
                  data-test="form-item-user-phone-number"
                >
                  <el-input
                    ref="mobile-pn-ref"
                    v-model="form.user.phone_number"
                    placeholder="-을 제외하고 번호만 입력해주세요"
                  />
                </el-form-item>
              </el-col>
              <el-col
                :xs="24"
                :md="12"
              >
                <el-form-item
                  label="이메일 계정"
                  prop="user.email"
                  data-test="form-item-user-email"
                >
                  <el-input
                    ref="mobile-email-ref"
                    v-model="form.user.email"
                    type="email"
                    placeholder="수신 가능한 이메일을 입력해주세요"
                  />
                </el-form-item>
                <el-form-item
                  label="비밀번호"
                  prop="user.password"
                  data-test="form-item-user-password"
                >
                  <el-input
                    ref="mobile-pw-ref"
                    v-model="form.user.password"
                    type="password"
                    placeholder="8자리 이상의 영문/숫자를 조합해주세요"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-button
              class="default register-form__submit register-form__next-btn"
              @click="handleMovePageWithValidation"
            >
              다음
            </el-button>
          </div>
        </div>
        <div class="page-wrapper">
          <div 
            class="page-scroll-wrapper" 
            :style="{visibility : mbPageIndex === 0 ? 'hidden' : 'visible' }"
          >
            <el-row :gutter="15">
              <el-col
                :xs="24"
                :md="12"
              >
                <el-form-item
                  label="센터명"
                  prop="name"
                  data-test="form-item-center-name"
                >
                  <el-input
                    v-model="form.name"
                    placeholder="센터의 공식 명칭을 입력해주세요"
                  />
                </el-form-item>
                <el-form-item
                  label="센터 타입"
                  prop="category"
                  data-test="form-item-category"
                >
                  <el-select
                    v-model="form.category"
                    placeholder="센터의 타입을 선택해주세요"
                    data-test="select-category"
                    :popper-append-to-body="true"
                  >
                    <el-option
                      v-for="(exerciseType, index) in exerciseTypeOptions"
                      :key="index"
                      :label="exerciseType.label"
                      :value="exerciseType.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="센터 주소"
                  data-test="form-item-address"
                  prop="address"
                >
                  <AddressInputWithMap
                    :map-visible="false"
                    :show-guide="false"
                    :address="form.address"
                    @change="onAddressChange"
                  />
                </el-form-item>
                <el-form-item prop="exercise_type">
                  <div slot="label">
                    센터 로고 (선택)
                    <span class="label-description">
                      가입 후 등록하거나 다른 로고로 교체하실 수 있습니다.<br>
                      (400 x 400px 사이즈 권장/ jpg , png  지원 /최대 3MB)
                    </span>
                  </div>
                  <CenterLogoUploadField 
                    :origin-logo-image-src="form.logo"
                    @change="onLogoImageChanged"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="15">
              <el-col :span="24">
                <el-form-item
                  label="피플박스 유입 경로"
                  prop="inflow"
                  data-test="form-item-inflow"
                >
                  <el-select
                    v-model="form.inflow"
                    placeholder="피플박스 유입 경로를 선택해주세요"
                    @change="form.inflow_detail = ''"
                    :popper-append-to-body="true"
                    :disabled="inflowInputDisabled"
                    class="inflow-select-input"
                  >
                    <el-option
                      v-for="(inflowOption, index) in inflowOptions"
                      :key="index"
                      :label="inflowOption.label"
                      :value="inflowOption.value"
                    />
                  </el-select>
                  <el-form-item
                    v-if="form.inflow === 4 || form.inflow === 5 || form.inflow === 6"
                    prop="inflow_detail"
                    class="inflow-write-input"
                  >
                    <el-input
                      v-model="form.inflow_detail"
                      :placeholder="presentInflowDetailPlaceholder"
                      :disabled="inflowInputDisabled"
                    />
                  </el-form-item>
                  <span
                    v-if="form.inflow === 4"
                    class="inflow-description"
                  >
                    추천인 입력 시 특별 프로모션이 적용됩니다. (유료 결제 시 1개월 무료)
                  </span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="15">
              <el-col :span="24">
                <el-form-item label="필수 동의 항목">
                  <el-checkbox
                    v-model="isPolicyChecked1"
                    data-test="policy-check"
                    class="policy-check"
                    size="medium"
                  >
                    <a
                      href="https://fiflfifl.com/terms-conditions"
                      target="_blank"
                    >
                      서비스 이용약관
                    </a> 및
                    <a
                      href="https://fiflfifl.com/privacypolicy"
                      target="_blank"
                    >
                      개인정보 처리방침
                    </a>를 읽었으며 이에 동의합니다.
                  </el-checkbox>
                  <br>
                  <el-checkbox
                    v-model="isPolicyChecked2"
                    data-test="policy-check2"
                    class="policy-check"
                    size="medium"
                  >
                    부정한 목적 및 타사업장으로 가입한 사실이 밝혀질 경우 관련된 모든 계정의 접근이 통보없이 차단됩니다.
                  </el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-button
              class="default register-form__submit"
              :disabled="!isFormValidated"
              :loading="isLoading"
              data-test="register-form-submit-button"
              @click="handleSignUp"
            >
              파트너사 가입
            </el-button>
          </div>
        </div>
      </el-form>
    </div>
    <referral-welcome-dialog 
      :dialog-visible="referralWelcomeDialogVisible"
      :dialog-center-name="referralCenterName"
      @close="closeReferralWelcomeModal"
    />
  </div>
</template>

<script>
import {
  validateName,
  validateEmailOnSignup,
  validateCenterTitle,
  validatePhoneNum,
  validatePassword,
  validateInflow
} from '@/utils/form-validate-rules';
import TopAnnounceBar from '@/pages/Layout/TopAnnounceBar';
import CenterLogoUploadField from '@/components/CenterLogoUploadField';
import ReferralWelcomeDialog from '@/components/ReferralWelcomeDialog';
import AddressInputWithMap from '@/components/AddressInputWithMap';
import { fiflboxApi } from '@/utils/api';

const EXERCISE_TYPES = [
  { label: '1:1 PT', value: 'PT' },
  { label: '그룹 트레이닝', value: 'GX' },
  { label: '부티크 피트니스', value: 'BQ' },
  { label: '일반 피트니스센터', value: 'HL' },
  { label: '필라테스', value: 'PL' },
  { label: '요가', value: 'YG' },
  { label: '크로스핏', value: 'CF' },
  { label: '농구', value: 'BB' },
  { label: '테니스', value: 'TN' },
  { label: '야구', value: 'ML' },
  { label: '축구', value: 'FB' },
  { label: '스피닝', value: 'SP' },
  { label: '발레', value: 'BL' },
  { label: '복싱', value: 'BX' },
  { label: '댄스', value: 'DN' },
  { label: '골프', value: 'GF' },
  { label: '기타', value: 'XY' }
];

const INFLOW_OPTIONS = [
  { value: 4, label: '지인 추천' },
  { value: 2, label: '인스타그램/페이스북 광고' },
  { value: 7, label: '유튜브 광고' },
  { value: 3, label: '홍보 이메일' },
  { value: 1, label: '인터넷 검색' },
  { value: 5, label: '기타' }
  // {value: 6, label: "지인 추천"},
];

export default {
  name: 'RegisterPage',
  components: {
    AddressInputWithMap,
    CenterLogoUploadField,
    TopAnnounceBar,
    ReferralWelcomeDialog
  },
  data() {
    return {
      exerciseTypeOptions: EXERCISE_TYPES,
      inflowOptions: INFLOW_OPTIONS,
      referralWelcomeDialogVisible: false,
      referralCenterName: '',
      isReferralPage: false,
      inflowInputDisabled: false,
      mbPageIndex: 0,
      form: {
        category: '',
        name: '',
        latitude: '',
        longitude: '',
        address: '',
        user: {
          name: '',
          email: '',
          phone_number: '',
          password: ''
        },
        inflow: null,
        inflow_detail: '',
        inflow_querystring: '',
        logo: null
      },
      isFormValid: {
        name: false,
        'user.name': false,
        'user.email': false,
        'user.phone_number': false,
        'user.password': false,
        inflow_detail: true
      },
      formValidateRules: {
        name: [{ validator: validateCenterTitle, trigger: 'blur' }],
        address: [
          {
            required: true,
            message: 'Please input Activity name',
            trigger: 'blur'
          }
        ],
        'user.name': [{ validator: validateName, trigger: 'blur' }],
        'user.email': [{ validator: validateEmailOnSignup, trigger: 'blur' }],
        'user.phone_number': [{ validator: validatePhoneNum, trigger: 'blur' }],
        'user.password': [{ validator: validatePassword, trigger: 'blur' }],
        inflow_detail: [{ validator: validateInflow, trigger: 'blur' }]
      },
      isPolicyChecked1: false,
      isPolicyChecked2: false,
      isLoading: false
    };
  },
  computed: {
    isFormValidated() {
      return (
        Object.values(this.isFormValid).every(i => i) &&
        this.isPolicyChecked1 &&
        this.isPolicyChecked2
      );
    },
    isMoblieFirstPageValidated() {
      let validateCnt = 0;
      const VALIDATE_TARGET = 4;
      for (let key in this.isFormValid) {
        if (key.includes('user.') && this.isFormValid[key] === true) {
          validateCnt++;
        }
      }
      return validateCnt === VALIDATE_TARGET;
    },
    presentInflowDetailPlaceholder() {
      if (this.form.inflow === 4) {
        return '추천인/파트너사 명을 입력해주세요.';
      }

      if (this.form.inflow === 5) {
        return '유입 경로를 자세히 적어주세요.';
      }

      return '';
    }
  },
  watch: {
    ['form.inflow'](value) {
      this.onFormValidChange(value);
    }
  },
  async mounted() {
    this.setInitialEmailValue();
    this.setInitialReferralValue();
    this.form.inflow_querystring = location.hash.replace('#/register', '');
    await fiflboxApi.default.deleteHeadersAuthorization();
  },
  methods: {
    async setInitialEmailValue() {
      const isEmailInQuery = 'email' in this.$router.currentRoute.query;
      if (isEmailInQuery) {
        this.form.user.email = this.$router.currentRoute.query.email;
        this.emailFormForceValidation();
        this.registerMailChimp(this.form.user.email);
      }
    },
    async setInitialReferralValue() {
      const isReferralCodeInQuery =
        'referral_code' in this.$router.currentRoute.query;
      if (isReferralCodeInQuery) {
        const referralCode = this.$router.currentRoute.query.referral_code;
        try {
          //DB에 센터 이름이 존재하면
          const responseToApi = await fiflboxApi.v2.getCenterNameByCode({
            center_code: referralCode
          });

          this.isReferralPage = true;
          //inflow select에 새로운 option을 추가하고 이를 자동 선택 되도록 한다.
          //또한 input은 disabled 처리를 해준다.
          this.inflowOptions.push({ value: 6, label: '지인 추천' });
          const { name: center_name } = responseToApi.data[0];
          this.form.inflow = 6;
          this.inflowInputDisabled = true;
          this.form.inflow_detail = center_name;

          //리퍼럴 환영 모달을 열고, 센터이름을 할당한다.
          this.referralCenterName = center_name;
          this.referralWelcomeDialogVisible = true;
        } catch (err) {
          return;
        }
      } else {
        this.inflowOptions = this.inflowOptions.slice(0, 6);
      }
    },
    handleMovePage(direction) {
      if (direction === 'next') {
        const { mbForm } = this.$refs;
        mbForm.style.right = '100%';
        this.mbPageIndex++;
      }
      //if direction is back
      else {
        if (this.mbPageIndex === 0) {
          //로그인페이지 이동
          window.location.href = '/';
        } else {
          const { mbForm } = this.$refs;
          mbForm.style.right = '0%';
          this.mbPageIndex--;
        }
      }
    },
    async registerMailChimp(email) {
      // 기존 sqsp에서 사용하던 로직을 CA에서 사용하기위해 구현함
      try {
        await fiflboxApi.v2.postMailChimpSubscribe({ email: email });
      } catch (err) {
        throw err;
      }
    },
    onFormValidChange(inflow) {
      const isInflow = inflow === 4 || inflow === 5;
      this.isFormValid['inflow_detail'] = !isInflow;
    },
    onLogoImageChanged(image) {
      this.form.logo = image;
      if (this.form.logo) {
        this.isFormValid.logo = true;
      } else {
        this.isFormValid.logo = false;
      }
    },
    onValidateChange($event, isValidated) {
      this.isFormValid[$event] = isValidated;
    },
    onAddressChange({ address, coordinate }) {
      this.form.address = address;
      this.form.latitude = coordinate.latitude;
      this.form.longitude = coordinate.longitude;
    },
    makeSignupErrorMessage(data) {
      let errorMessage = '';

      if (data.category) {
        errorMessage += '센터 타입 에러: 올바른 센터 타입을 선택 해주세요.\n';
      }

      if (data.address) {
        errorMessage += '센터 주소 에러: 주소를 검색하여 입력해주세요.\n';
      }

      if (data.inflow) {
        errorMessage += '가입 경로 미기입 에러: 가입 경로를 선택해주세요.';
      }

      return errorMessage;
    },
    async submitSignupData() {
      try {
        await fiflboxApi.v2.postSignup(this.form);

        return {
          isSuccess: true
        };
      } catch (err) {
        let { data } = err.response;
        const errorMessage = this.makeSignupErrorMessage(data);

        return {
          isSuccess: false,
          errorMessage: {
            title: '회원가입 오류',
            message: errorMessage
          }
        };
      }
    },
    async showFailAlert({ message, title }) {
      await this.$alert(message, title);
      return true;
    },
    async loginUser({ email, password }) {
      try {
        let { data: loginResult } = await fiflboxApi.v2.postLogin(
          {},
          {
            auth: {
              username: this.form.user.email,
              password: this.form.user.password
            }
          }
        );

        this.$tokenStorage.setToken(loginResult.token);

        const bearerToken = this.$tokenStorage.getBearerToken();

        fiflboxApi.default.setHeadersAuthorization(bearerToken);
        return {
          isSuccess: true
        };
      } catch (err) {
        return {
          isSuccess: false,
          errorMessage: {
            title: '로그인 오류',
            message:
              '회원가입에는 성공하였지만 로그인에는 실패했습니다.\n로그인 페이지로 이동하여 로그인을 시도해주세요.'
          }
        };
      }
    },
    moveToOnboardingPage() {
      if (window.innerWidth < 768) {
        this.$router.push('mobile-onboarding').catch(() => {});
      } else {
        location.href = '/#/dashboard?onboarding=true';
      }
    },
    async handleSignUp() {
      this.isLoading = true;
      const signupResult = await this.submitSignupData();

      if (!signupResult.isSuccess) {
        const isClose = await this.showFailAlert(signupResult.errorMessage);
        if (isClose) {
          this.isLoading = false;
          return;
        }
      }

      const loginResult = await this.loginUser(this.form.user);

      if (!loginResult.isSuccess) {
        const isClose = await this.showFailAlert(signupResult.errorMessage);
        if (isClose) {
          this.isLoading = false;
          return;
        }
      }

      this.moveToOnboardingPage();
      this.isLoading = false;
    },
    closeReferralWelcomeModal() {
      this.referralWelcomeDialogVisible = false;
    },
    async emailFormForceValidation() {
      await this.$refs['desktop-email-ref'].focus();
      await this.$refs['desktop-email-ref'].blur();

      await this.$refs['mobile-email-ref'].focus();
      await this.$refs['mobile-email-ref'].blur();
    },
    async handleMovePageWithValidation() {
      let isValidate = true;
      if (!this.isFormValid['user.name']) {
        isValidate = false;
        await this.$refs['mobile-name-ref'].focus();
        await this.$refs['mobile-name-ref'].blur();
      }

      if (!this.isFormValid['user.email']) {
        isValidate = false;
        await this.$refs['mobile-email-ref'].focus();
        await this.$refs['mobile-email-ref'].blur();
      }

      if (!this.isFormValid['user.phone_number']) {
        isValidate = false;
        await this.$refs['mobile-pn-ref'].focus();
        await this.$refs['mobile-pn-ref'].blur();
      }

      if (!this.isFormValid['user.password']) {
        isValidate = false;
        await this.$refs['mobile-pw-ref'].focus();
        await this.$refs['mobile-pw-ref'].blur();
      }

      if (isValidate) {
        return this.handleMovePage('next');
      }
    }
  }
};
</script>

<style lang="scss">
.register-page {
  .announce-bar__container {
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 2000;
    @media screen and (max-width: 768px) {
      position: relative;
    }
  }
  @media screen and (max-width: 768px) {
    overflow: hidden;
    height: 100%;
  }

  span.label-description {
    line-height: 14px !important;
  }
}
.inflow-write-input {
  margin-top: 10px;
  margin-bottom: 5px !important;
}
.inflow-write-input.is-error {
  .el-form-item__error {
    position: relative;
    transform: translateY(3px);
  }
}
.inflow-description {
  display: block;
  font-size: 11px;
  font-weight: normal;
  letter-spacing: -0.7px;
  color: #9b9b9b;
  margin-top: 0px;
  line-height: 20px;
}
.register-header {
  margin-top: 100px;
  margin-bottom: 70px;
  text-align: center;

  h1 {
    margin-top: 38px;
    font-size: 25px;
    font-weight: normal;
    line-height: 37px;
    letter-spacing: -1px;
    color: #4a4a4a;
    margin-bottom: 11px;
  }

  span {
    font-size: 14px;
    line-height: 20px;
    font-weight: normal;
    letter-spacing: -0.6px;
    text-align: center;
    color: #4a4a4a;
  }

  @media screen and (max-width: 768px) {
    display: none;
  }
}

.mb__register-header__container {
  position: relative;
  z-index: 2000;
}

.mb__register-header {
  display: none;
  box-sizing: border-box;
  position: relative;
  background-color: #ffffff;
  height: 44px;
  width: 100%;
  .ic-arrow-left {
    width: 23px;
    height: 23px;
    position: absolute;
    border: none;
    background-color: initial;
    background-position: center;
    top: 10px;
    left: 10px;
  }
  h1 {
    width: 100%;
    margin: auto;
    color: #202020;
    font-size: 18px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.8px;
    text-align: center;
  }
  @media screen and (max-width: 768px) {
    display: flex;
  }
}

.register-form-container {
  width: 50%;
  margin: 0 auto 60px;

  .register-form__submit {
    width: 350px;
  }

  @media screen and (max-width: 768px) {
    display: none;
  }
}

.mb__register-form-container {
  display: none;
  position: relative;
  width: 200%;
  height: calc(100% - 44px);
  overflow: hidden;
  padding: 20px 0 0;
  box-sizing: border-box;
  @media screen and (max-width: 768px) {
    display: block;
    .el-form {
      display: flex;
      flex-wrap: nowrap;
      padding: 0;
      height: 100%;

      .page-scroll-wrapper {
        padding-bottom: 100px;
      }
      .page-wrapper {
        overflow-x: hidden;
        overflow-y: auto;
        width: 100%;
        height: 100%;
        padding: 0 40px;
      }
      .page-wrapper::-webkit-scrollbar {
        display: none;
      }
    }
  }
}
.policy-check {
  width: 100%;
  .el-checkbox__label {
    max-width: initial;
  }
  a {
    color: #6c6c6c;
    text-decoration: #6c6c6c underline;
  }
}

.logo-upload-fields {
  width: 100px;
  height: 100px;
  border-radius: 10px;
  background-color: #f2f2f2;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border: dotted 1px #b9b9b9;
  cursor: pointer;

  .plus-icon {
    font-size: 14px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    font-weight: bold;
  }

  input[type='file'] {
    display: none;
  }
  &:hover {
    border: dotted 1px #4a4a4a;
  }
}
</style>
